import { render, staticRenderFns } from "./Strategies.vue?vue&type=template&id=16306720&"
import script from "./Strategies.vue?vue&type=script&lang=js&"
export * from "./Strategies.vue?vue&type=script&lang=js&"
import style0 from "./Strategies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports